var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "collapse bd-links",
    attrs: {
      "id": "bd-docs-nav"
    }
  }, _vm._l((_vm.navs), function(group) {
    return _c('div', {
      staticClass: "bd-toc-item",
      class: {
        active: true
      }
    }, [_c('router-link', {
      staticClass: "bd-toc-link",
      attrs: {
        "to": group.children[0].link
      }
    }, [_vm._v(_vm._s(group.group))]), _vm._v(" "), _c('ul', {
      staticClass: "nav bd-sidenav"
    }, _vm._l((group.children), function(li) {
      return _c('router-link', {
        key: li.link,
        attrs: {
          "tag": "li",
          "to": li.link,
          "active-class": "active bd-sidenav-active"
        }
      }, [_c('a', [_vm._v(_vm._s(li.name))])])
    }))], 1)
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85be27d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/components/SidebarNav.vue
// module id = 101
// module chunks = 19